import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { DailyWork } from '../state-man/models/daily-work.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class DailyWorkService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  // version: the one that came with the daily work already held, or '' for none.
  public async getScheduled (version: string, work_date: string='') : Promise<{ version: string, rows: DailyWork[] | null } | null> {
    try {
      const ret = await this.apiService.getVersionedList('technician_daily_work/scheduled/' + work_date, version)
      return ret && { version: ret.version, rows: ret.rows && DailyWork.buildMany(ret.rows) }
    } 
    catch (error) {   
      LoggerService.log(error + 'technician_daily_work/scheduled/')    
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')     
      return null
    }
    
  }  
}
